// ORP (Optimal Recognition Point) calculation for RSVP word display.
// Identifies which letter the reader's eye should fixate on per word.

export const getLetterBody = (word) => {
  const start = word.search(/[a-zA-Z0-9']/);
  if (start === -1) return { body: word, offset: 0 };
  const bodyMatch = word.slice(start).match(/^[a-zA-Z0-9']+/);
  const body = bodyMatch ? bodyMatch[0] : word.slice(start);
  return { body, offset: start };
};

export const calcORP = (word, mode) => {
  const { body, offset } = getLetterBody(word);
  const len = body.length;
  if (len === 0) return 0;
  let bodyIdx;
  switch (mode) {
    case "start": bodyIdx = 0; break;
    case "center": bodyIdx = Math.floor(len / 2); break;
    case "end": bodyIdx = len - 1; break;
    default:
      if (len === 1) bodyIdx = 0;
      else if (len <= 3) bodyIdx = 0;
      else if (len <= 5) bodyIdx = 1;
      else if (len <= 7) bodyIdx = 2;
      else if (len <= 11) bodyIdx = 3;
      else bodyIdx = 4;
      break;
  }
  return offset + Math.min(bodyIdx, word.length - 1);
};

export const hasPunct = (w) => /[.!?,;:—–\-]$/.test(w);

// Delay (ms) after loading screen completes before RSVP auto-starts.
// Gives the user time to orient before words begin streaming.
export const RSVP_START_DELAY = 1200;
